import { render, staticRenderFns } from "./dateDelivery.vue?vue&type=template&id=96c993a0&scoped=true"
import script from "./dateDelivery.vue?vue&type=script&lang=js"
export * from "./dateDelivery.vue?vue&type=script&lang=js"
import style0 from "./dateDelivery.vue?vue&type=style&index=0&id=96c993a0&prod&scoped=true&lang=css"
import style1 from "./dateDelivery.vue?vue&type=style&index=1&id=96c993a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c993a0",
  null
  
)

export default component.exports